module.exports = __webpack_public_path__ + "static/media/linkCard_evs.1e9c8314.svg";